import firebase from 'firebase'
import { SET_USER, SHOW_ALERT } from '../actions'
const authModule = () => firebase.auth ()
const state = {
	user: null
}

const actions = {

	// Send the email and password to firebase and returns an error if exists
	createUserWithEmailAndPassword: (store, payload) => {
		authModule ()
			.createUserWithEmailAndPassword (payload.email, payload.password)
			.then (user => {

				store.commit (SET_USER, user)

				console.log (user)				
				authModule ().currentUser.sendEmailVerification ()
					.then (() => {
						store.commit (SHOW_ALERT, {
							text: 'Verify your mail',
							message: `A verification mail has been sent to ${payload.email}`,
							dismissable: true,
							actions: []
						})
					}).catch (err => {
						console.log ('Error sending verification email: ', err)
					})
			})
			.catch (err => {
				console.log ('Error during sign up: ', err)
				store.commit (SHOW_ALERT, {
					text: 'Error during authentication',
					message: err.message,
					dismissable: true,
					actions: []
				})
				store.commit (SET_USER, null)
			})
	},

	// Send all the info of the user to firebase storage
	createUser: (store, payload) => {
		
		authModule ()
			.createUserWithEmailAndPassword (payload.email, payload.password)
			.then (user => {

				store.commit (SET_USER, user)

				console.log (user)				
				authModule ().currentUser.sendEmailVerification ()
					.then (() => {
						store.commit (SHOW_ALERT, {
							text: 'Verify your mail',
							message: `A verification mail has been sent to ${payload.email}`,
							dismissable: true,
							actions: []
						})
						store.commit ('dismissAuthentication')
						firebase.database ().ref ('users/' + user.user.uid).set ({
							name: payload.name,
							surname:payload.surname,
							phone: payload.phone,
							birth: payload.birth,
							address: payload.address,
							country: payload.country,
							defaultAccount: payload.defaultAccount
						}).then (() => {
							// Uploade user documents
							if (payload.userPhoto && payload.userDocument && payload.userInvoice) {
								firebaseStorage.upload (user.user.uid, payload.userPhoto, 'photo')
								firebaseStorage.upload (user.user.uid, payload.userDocument, 'id')
								firebaseStorage.upload (user.user.uid, payload.userInvoice, 'invoice')
							}
						}).catch ( error => {
							console.log (error)
						})
					})
					.catch (err => {
						console.log ('Error sending verification email: ', err)
					})
			})
			.catch (err => {
				console.log ('Error during sign up: ', err)
				store.commit (SHOW_ALERT, {
					text: 'Error during authentication',
					message: err.message,
					dismissable: true,
					actions: []
				})
				store.commit (SET_USER, null)
			})
	},
	
	updateProfile: ({ commit, state }, profile) => {
		if(!profile)
			return

		state.user
			.updateProfile (profile)
			.then (() => {
				console.log ('update success', profile)
				commit (SET_USER, {...state.user, profile})
			})
			.catch (err => {
				console.log (err)
				commit (SHOW_ALERT, {
					text: 'Error during user update',
					message: err.message,
					dismissable: true,
					actions: []
				})
			})
	},
	authenticateUser: async (store, { email, password }) => {
		try {
			let user = await authModule ().signInWithEmailAndPassword (email, password)
			store.commit (SET_USER, user.user)
			if (user && !user.emailVerified) {
				store.commit (SHOW_ALERT, {
					text: 'Verify your email',
					message: 'You need to verify your email to log in',
					dismissable: true,
					actions: [
						{
							text: 'Resend email',
							type: 'success',
							handler: () => {
								authModule ().currentUser.sendEmailVerification ()
							}
						}
					]
				})
			}
		} catch (err) {
			console.log (err)
			store.commit (SET_USER, null)
			store.commit (SHOW_ALERT, {
				text: 'Error during authentication',
				message: err.message,
				dismissable: true,
				actions: []
			})
		}
	}
}

const mutations = {
	[SET_USER]: (state, user) => {
		state.user = user
	},
	logout () {
		authModule ().signOut ()
	}
}

const getters = {
	user: state => state.user
}

const firebaseStorage = {
	upload (userID, file, ofKind) {

		if (!file) {
			console.log ('No file to upload')
			return
		}

		// Uploade the invoice's photo
		const fileName = file.name
		const ext = fileName.slice ( fileName.lastIndexOf ('.'))
	
		switch (ofKind) {
		case 'id':
			firebase.storage ().ref ('users/' + userID + '/documents/card-id' + ext).put (file)
				.then (fileData => {
					console.log (fileData)
					let url
					url = fileData.metadata.fullPath
					return firebase.database ().ref ('users/').child (userID).update ({idCardUrl: url})
				}).catch ( error => {
					console.log (error)
				})
			break
		case 'photo':
			firebase.storage ().ref ('users/' + userID + '/documents/photo' + ext).put (file)
				.then (fileData => {
					console.log (fileData)
					let url
					url = fileData.metadata.fullPath
					return firebase.database ().ref ('users/').child (userID).update ({photoUrl: url})
				}).catch ( error => {
					console.log (error)
				})
			break
		case 'invoice':
			firebase.storage ().ref ('users/' + userID + '/documents/invoice' + ext).put (file)
				.then (fileData => {
					console.log (fileData)
					let url
					url = fileData.metadata.fullPath
					return firebase.database ().ref ('users/').child (userID).update ({invoiceUrl: url})
				}).catch ( error => {
					console.log (error)
				})
			break
		default:
			console.log ('Upload', fileName ,'failed')
			return
		}
	}
}

export default {
	state,
	actions,
	mutations,
	getters
}